import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const CLIENT_KEY = "cm_client_token";
const ADMIN_KEY = "cm_admin_token";
export const ADMIN_TOKEN_KEY = ADMIN_KEY;
const CART_KEY = "cm_cart";

// ---------- Token helpers ----------
export const tokens = {
  getClient: () => localStorage.getItem(CLIENT_KEY),
  setClient: (t) => localStorage.setItem(CLIENT_KEY, t),
  clearClient: () => localStorage.removeItem(CLIENT_KEY),
  getAdmin: () => localStorage.getItem(ADMIN_KEY),
  setAdmin: (t) => localStorage.setItem(ADMIN_KEY, t),
  clearAdmin: () => localStorage.removeItem(ADMIN_KEY),
};

// ---------- Axios instances ----------
export const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((cfg) => {
  const t = tokens.getClient();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = tokens.getAdmin();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// ---------- Cart persistence ----------
export const cartStorage = {
  load: () => {
    try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); }
    catch { return []; }
  },
  save: (items) => localStorage.setItem(CART_KEY, JSON.stringify(items)),
  clear: () => localStorage.removeItem(CART_KEY),
};

// ---------- Formatter ----------
export const formatCOP = (n) => {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n);
};
